import React, { useEffect, useState } from "react";
import { BellOff, BellRing } from "lucide-react";
import { Button } from "./ui/button";
import { toast } from "sonner";
import { pushSupported, isPushSubscribed, enablePush, disablePush, resyncPush } from "../lib/push";

export function PushToggle() {
  const [supported] = useState(pushSupported());
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    isPushSubscribed().then((sub) => {
      setOn(sub);
      if (sub) resyncPush();
    }).catch(() => {});
  }, []);
  if (!supported) return null;
  const toggle = async () => {
    setBusy(true);
    try {
      if (on) { await disablePush(); setOn(false); toast.success("Notificaciones push desactivadas"); }
      else { await enablePush(); setOn(true); toast.success("Notificaciones push activadas en este dispositivo"); }
    } catch (e) {
      toast.error(e.message || "No se pudo cambiar las notificaciones");
    } finally { setBusy(false); }
  };
  return (
    <Button variant="outline" size="sm" className="gap-2" onClick={toggle} disabled={busy} data-testid="push-toggle"
      title={on ? "Desactivar notificaciones push" : "Activar notificaciones push"}>
      {on ? <BellRing className="h-4 w-4 text-primary" /> : <BellOff className="h-4 w-4" />}
      <span className="hidden sm:inline">{on ? "Push activo" : "Activar push"}</span>
    </Button>
  );
}

export default PushToggle;
